import { Icon } from '@iconify/react';
import _ from "lodash";
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { getPositiveDisplacementSuggestion, updateEquipmentUnitInfo } from '../../../api';
import { checkForAPISuccess, showErrorToast, showSuccessToast } from '../../../Common/commonFunctions';
import { ClipLoader } from 'react-spinners';
import { useDispatch } from 'react-redux';
import { SET_ONGOING_EDIT_GLOBALLY, UPDATE_EQUIPMENT_UNIT_POSITIVE_DISPLACEMENT } from '../../../store/actions';
import { useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';

const EquipmentUnitPositiveDisplacementField = (props) => {

    const dispatch = useDispatch();
    const isEditOngoing = useSelector(state => state.equipment.isEditOngoing);
    const isLockedProfile = useSelector(state => state.equipment.isLockedProfile);

    const [utils, setUtils] = useState({ isEditActive: false, isPositiveDisplacement: "", suggestion: "" });

    useEffect(() => {
        setUtils({ ...utils, isPositiveDisplacement: props?.positiveDisplacement });
    }, []);

    const updatePositiveDisplacementField = async () => {
        console.log(props.id);
        
        const { data } = await updateEquipmentUnitInfo(props.id, { isPositiveDisplacement: utils.isPositiveDisplacement });

        if(checkForAPISuccess(data.statusCode)) {
            showSuccessToast("Updated successfully");
            setUtils({ ...utils, isEditActive: false });
            dispatch({
                type: UPDATE_EQUIPMENT_UNIT_POSITIVE_DISPLACEMENT,
                payload: { name: props.name, positiveDisplacement: utils.isPositiveDisplacement }
            });
        }
        else {
            showErrorToast("Failed to update");
            setUtils({ ...utils, isEditActive: false, isPositiveDisplacement: props.positiveDisplacement });
            dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: false })
        }
    }

    const updatePositiveDisplacementFieldMutation = useMutation(updatePositiveDisplacementField)

    const getSuggestion = async () => {
        const { data } = await getPositiveDisplacementSuggestion(props.id);

        if(checkForAPISuccess(data?.statusCode)) {
            setUtils({ ...utils, suggestion: data?.data === true ? "Yes" : "No", isEditActive: true });
        }
        else {
            setUtils({ ...utils, suggestion: "Cannot get suggestion", isEditActive: true });
        }
    }

    const getSuggestionMutation = useMutation(getSuggestion);

    const handleEdit = (action) => {
        if(action === "ENABLE") {
            getSuggestionMutation.mutate();
        }
        else {
            setUtils({ ...utils, isEditActive: false, isPositiveDisplacement: props.positiveDisplacement })
        }
        dispatch({ type: SET_ONGOING_EDIT_GLOBALLY, payload: action === "ENABLE" });
    }

    const returnIcon = (icon, className, color, callBack) => 
        <Icon
            onClick={() => callBack()}
            className={className}
            icon={icon}
            width={20} height={20}
            color={color}
        />

    return (
        <div className="border-bottom-secondary">
            {
                updatePositiveDisplacementFieldMutation.isLoading || getSuggestionMutation.isLoading ?
                    <Col md={{ span: 12 }} className='equipment-unit-field-loader my-1'>
                        <ClipLoader color='#075978' size={25} />
                    </Col>
                        :
                    <div className='equipment-unit-field-container py-1'>
                        <div className='ml-2 w-50'>
                            Positive displacement
                        </div>
                        <div className='mr-1 w-50 justify-end'>
                            {
                                utils.isEditActive ?
                                    <div className='h-100 w-75'>
                                        <div className='justify-end'>
                                            <select
                                                onChange={(e) => setUtils({ ...utils, isPositiveDisplacement: e.target.value })}
                                                defaultValue={!_.isEmpty(props.positiveDisplacement) ? props.positiveDisplacement : "default"}
                                                className="edit-dropdown h-100 text-left mr-2"
                                            >
                                                <option disabled value={"default"}>Select</option>
                                                <option value={"Yes"}>Yes</option>
                                                <option value={"No"}>No</option>
                                            </select>
                                            {
                                                !_.isEmpty(utils.isPositiveDisplacement) &&
                                                (utils.isPositiveDisplacement !== props.positiveDisplacement) &&
                                                    <div>
                                                        { returnIcon("feather-check", "cursor-pointer", "#075978", () => updatePositiveDisplacementFieldMutation.mutate()) }
                                                    </div>
                                            }
                                            <div>
                                                { returnIcon("feather-x", "cursor-pointer", "grey", () => handleEdit("DISABLE")) }
                                            </div>
                                        </div>
                                        {
                                            !getSuggestionMutation.isLoading &&
                                                <div className='equipment-unit-field-suggestion'>
                                                    {utils.isEditActive && `Suggestion: ${utils.suggestion}`}
                                                </div>
                                        }
                                    </div>
                                        :
                                    <>
                                        <div className={"mr-2"}>
                                            { !_.isEmpty(props.positiveDisplacement) ? props.positiveDisplacement : "-" }
                                        </div>
                                        {
                                            !isLockedProfile &&
                                                returnIcon(
                                                    "feather-edit", isEditOngoing ? "disable-click mr-1" : "cursor-pointer mr-1",
                                                    isEditOngoing ? "grey" : "#075978", () => handleEdit("ENABLE")
                                                )
                                        }
                                    </>
                            }
                        </div>
                    </div>
            }
        </div>
    )
}

export default EquipmentUnitPositiveDisplacementField;